import { Routes } from '@angular/router';
import { CompanyComponent } from './components/pages/company/company.component';

export const routes: Routes = [
  { path: '', component: CompanyComponent },
  {
    path: 'p',
    loadChildren: () => import('./components/pages/pages.routes').then((m) => m.routes),
  },
];
